import { useBarcodeScanner } from "./use-barcode-scanner";
import { useSendEvent } from "./use-send-event";
import { toast } from "sonner";
import { useCurrentPos } from "./use-current-pos";
import { urlLoadProduct } from "../urls";
import { useNavigate } from "react-router";
import { useSetAtom } from "jotai";
import { productsAtom } from "../stores/pos";

export function useProductScan(from?: string) {
  const { club, pos } = useCurrentPos();
  const sendEvent = useSendEvent();
  const navigate = useNavigate();
  const setProducts = useSetAtom(productsAtom);
  useBarcodeScanner({
    onScan: (barcode) => {
      if (barcode === pos.clubToken) {
        navigate(urlLoadProduct(), { viewTransition: true });
        return;
      }
      const allProducts = club.productCategories.flatMap(
        (category) => category.products
      );
      const product = allProducts.find((product) => product.sku === barcode);
      if (product) {
        sendEvent("scan_product", {
          barcode,
          from,
          error: false,
        });
        setProducts((prev) => [...prev, product]);
        toast.success("Producto agregado");
      } else {
        sendEvent("scan_product", {
          barcode,
          from,
          error: true,
        });
        toast.error("Producto no encontrado");
      }
    },
  });
}
